import isUserLoggedIn from "@Middleware/isUserLoggedIn";

const AppShoppingCart = () => import(/* webpackChunkName: 'shopping_cart' */ "@Components/cart/Cart.vue");
const AppShoppingCartPaymentVerify = () => import(/* webpackChunkName: 'shopping_cart' */ "@Components/cart/Verify.vue");
const HomepageOverhauling = () => import( /* webpackChunkName: 'overhauling' */ "@Views/overhauling/homepage/HomepageOverhauling.vue");

export default [
  {
    path: "/app/shopping-cart",
    name: "shopping-cart",
    components: {
      default: HomepageOverhauling,
      right: AppShoppingCart,
    },
    meta: { middleware: [isUserLoggedIn] },
  },

  {
    path: "/app/shopping-cart/success",
    name: "shopping-cart.verify",
    components: {
      default: HomepageOverhauling,
      right: AppShoppingCartPaymentVerify,
    },
    meta: { middleware: [isUserLoggedIn] },
    beforeEnter: (to, from, next) => {
      if (
        sessionStorage.getItem("orderPurchaseSource") &&
        sessionStorage.getItem("orderPurchaseSource") === "freetrial"
      ) {
        next({
          name: "freetrial.domain-purchase-verification-modal",
          replace: true,
          query: to.query,
        });
      } else {
        next();
      }
    },
  },
];
